/*jslint browser: true*/
/*global $, jQuery*/
import 'select2';

jQuery(function ($) {
  /*
   * Function refreshes the pseudo tags. Is used by IE8 to
   * avoid the problem where the fonts load after the css has been parsed
   */
  function getFontFixStyleElement() {
    var style = $("#FontFixStyleElement");
    if (!style.length) {
      style = $(
        '<style type="text/css" id="FontFixStyleElement" disabled="disabled">' +
          ":before,:after{content:none !important}" +
          "</style>"
      ).appendTo("head");
    }
    return style;
  }

  $(".nav-collapse")
    .addClass("collapse")
    .addClass("collapsed")
    .on("hidden", function () {
      $(this).addClass("collapsed");
      $(this).siblings("button").attr("aria-expanded", "false");
    })
    .on("show", function () {
      $(this).removeClass("collapsed");
      $(this).siblings("button").attr("aria-expanded", "true");
    });

  $(".navbar a .showChildren").click(function (e) {
    e.preventDefault();
    var oldOpen = $(".navbar .open");
    $(this).closest("li").addClass("open");
    oldOpen.removeClass("open");
    return false;
  });

  // Don't let the Go! button submit the search form if it's empty.
  $('#SearchGroup input[type="submit"]').click(function () {
    var searchInput = $(this).siblings('input[type="search"]');
    var searchValue = $.trim(searchInput.val());
    if (searchValue.length == 0) {
      searchInput.focus();
      return false;
    }
  });

  // SITEMAP
  $(".sitemap").on("click", ".button", function () {
    var self = $(this);
    var target = $(self.attr("data-target"));

    // only do an ajax request if the content isn't loaded
    if (target.html().length == 0) {
      self.addClass("loading");

      $.ajax({
        url: self.attr("href"),
        data: { ajax: true },
      }).done(function (data) {
        target.html(data);
        self.removeClass("loading");
      });
    }

    self.toggleClass("open");

    if (self.hasClass("open")) {
      target.removeClass("collapse").addClass("collapsed");
      $(this).attr("aria-expanded", "true");
      $(this)
        .children(".linkText")
        .replaceWith('<span class="linkText">Collapse section</span>');
    } else {
      target.removeClass("collapsed").addClass("collapse");
      $(this).attr("aria-expanded", "false");
      $(this)
        .children(".linkText")
        .replaceWith('<span class="linkText">Expand section</span>');
    }

    return false;
  });

  $("#print-placeholder").replaceWith(
    '<button type="button" onclick="window.print(); return false;">Print</button>'
  );

  // Add additional title information to external links which open in an external window
  $('.content a[target="_blank"]').attr(
    "title",
    $('a[target="_blank"]').attr("title") +
      " - This link will open in a new window"
  );

  // Maori language class to add lang type
  $(".maori").attr("lang", "mi");

  // Customize validation for user forms. Accessibility fixes
  var siteForm = $(".UserDefinedForm #Form_Form");
  if (siteForm.length > 0) {
    // Set up validation.
    if (siteForm.find(".requiredField").length > 0) {
      siteForm.prepend(
        '<p class="req-indicator-message">Required fields are marked</p>'
      );
    }
  }

  function requireJuryAddress(state) {
    $("#Form_Form_StreetAddress").val("");
    $("#Form_Form_City").val("");
    $("#Form_Form_PostCode").val("");

    var req = '<span class="req-indicator">*</span>';

    if (state) {
      $("#Form_Form_StreetAddress").attr("required", "required");
      if ($("#Form_Form_StreetAddress_Holder label .req-indicator").length == 0)
        $("#Form_Form_StreetAddress_Holder label").append(req);

      $("#Form_Form_City").attr("required", "required");

      if ($("#Form_Form_City_Holder label .req-indicator").length == 0)
        $("#Form_Form_City_Holder label").append(req);

      $("#Form_Form_PostCode").attr("required", "required");

      if ($("#Form_Form_PostCode_Holder label .req-indicator").length == 0)
        $("#Form_Form_PostCode_Holder label").append(req);
    } else {
      $("#Form_Form_StreetAddress").attr("required", false);
      $("#Form_Form_StreetAddress_Holder label .req-indicator").remove();
      $("#Form_Form_City").attr("required", false);
      $("#Form_Form_City_Holder label .req-indicator").remove();
      $("#Form_Form_PostCode").attr("required", false);
      $("#Form_Form_PostCode_Holder label .req-indicator").remove();
    }
    $("#Form_Form_StreetAddress").attr("aria-required", state);
    $("#Form_Form_City").attr("aria-required", state);
    $("#Form_Form_PostCode").attr("aria-required", state);
  }

  function requireIndividualDetails(state) {
    $("#Form_Form_FirstName").val("");
    $("#Form_Form_Surname").val("");
    $("#Form_Form_BirthDate").val("");
    $("#Form_Form_Email").val("");
    $("#Form_Form_PhoneNumber").val("");
    $("#Form_Form_StreetAddress").val("");
    $("#Form_Form_City").val("");
    $("#Form_Form_PostCode").val("");

    var req = '<span class="req-indicator">*</span>';

    if (state) {
      $("#Form_Form_FirstName").attr("required", "required");
      if ($("#Form_Form_FirstName_Holder label .req-indicator").length == 0)
        $("#Form_Form_FirstName_Holder label").append(req);

      $("#Form_Form_Surname").attr("required", "required");
      if ($("#Form_Form_Surname_Holder label .req-indicator").length == 0)
        $("#Form_Form_Surname_Holder label").append(req);

      $("#Form_Form_BirthDate").attr("required", "required");
      if ($("#Form_Form_BirthDate_Holder label .req-indicator").length == 0)
        $("#Form_Form_BirthDate_Holder label").append(req);

      $("#Form_Form_Email").attr("required", "required");
      if ($("#Form_Form_Email_Holder label .req-indicator").length == 0)
        $("#Form_Form_Email_Holder label").append(req);

      $("#Form_Form_PhoneNumber").attr("required", "required");
      if ($("#Form_Form_PhoneNumber_Holder label .req-indicator").length == 0)
        $("#Form_Form_PhoneNumber_Holder label").append(req);

      $("#Form_Form_StreetAddress").attr("required", "required");
      if ($("#Form_Form_StreetAddress_Holder label .req-indicator").length == 0)
        $("#Form_Form_StreetAddress_Holder label").append(req);

      $("#Form_Form_City").attr("required", "required");
      if ($("#Form_Form_City_Holder label .req-indicator").length == 0)
        $("#Form_Form_City_Holder label").append(req);

      $("#Form_Form_PostCode").attr("required", "required");
      if ($("#Form_Form_PostCode_Holder label .req-indicator").length == 0)
        $("#Form_Form_PostCode_Holder label").append(req);
    } else {
      $("#Form_Form_FirstName").attr("required", false);
      $("#Form_Form_FirstName_Holder label .req-indicator").remove();

      $("#Form_Form_Surname").attr("required", false);
      $("#Form_Form_Surname_Holder label .req-indicator").remove();

      $("#Form_Form_BirthDate").attr("required", false);
      $("#Form_Form_BirthDate_Holder label .req-indicator").remove();

      $("#Form_Form_Email").attr("required", false);
      $("#Form_Form_Email_Holder label .req-indicator").remove();

      $("#Form_Form_PhoneNumber").attr("required", false);
      $("#Form_Form_PhoneNumber_Holder label .req-indicator").remove();

      $("#Form_Form_StreetAddress").attr("required", false);
      $("#Form_Form_StreetAddress_Holder label .req-indicator").remove();

      $("#Form_Form_City").attr("required", false);
      $("#Form_Form_City_Holder label .req-indicator").remove();

      $("#Form_Form_PostCode").attr("required", false);
      $("#Form_Form_PostCode_Holder label .req-indicator").remove();
    }
    $("#Form_Form_FirstName").attr("aria-required", state);
    $("#Form_Form_Surname").attr("aria-required", state);
    $("#Form_Form_BirthDate").attr("aria-required", state);
    $("#Form_Form_Email").attr("aria-required", state);
    $("#Form_Form_PhoneNumber").attr("aria-required", state);
    $("#Form_Form_StreetAddress").attr("aria-required", state);
    $("#Form_Form_City").attr("aria-required", state);
    $("#Form_Form_PostCode").attr("aria-required", state);
  }

  function requireorganisationDetails(state) {
    $("#Form_Form_OrganisationName").val("");
    $("#Form_Form_OrganisationContactName").val("");
    $("#Form_Form_OrganisationEmail").val("");
    $("#Form_Form_OrganisationPhone").val("");
    $("#Form_Form_OrganisationStreetAddress").val("");
    $("#Form_Form_OrganisationCity").val("");
    $("#Form_Form_OrganisationPostCode").val("");

    var req = '<span class="req-indicator">*</span>';

    if (state) {
      $("#Form_Form_OrganisationName").attr("required", "required");
      if (
        $("#Form_Form_OrganisationName_Holder label .req-indicator").length == 0
      )
        $("#Form_Form_OrganisationName_Holder label").append(req);

      $("#Form_Form_OrganisationContactName").attr("required", "required");
      if (
        $("#Form_Form_OrganisationContactName_Holder label .req-indicator")
          .length == 0
      )
        $("#Form_Form_OrganisationContactName_Holder label").append(req);

      $("#Form_Form_OrganisationEmail").attr("required", "required");
      if (
        $("#Form_Form_OrganisationEmail_Holder label .req-indicator").length ==
        0
      )
        $("#Form_Form_OrganisationEmail_Holder label").append(req);

      $("#Form_Form_OrganisationPhone").attr("required", "required");
      if (
        $("#Form_Form_OrganisationPhone_Holder label .req-indicator").length ==
        0
      )
        $("#Form_Form_OrganisationPhone_Holder label").append(req);

      $("#Form_Form_OrganisationStreetAddress").attr("required", "required");
      if (
        $("#Form_Form_OrganisationStreetAddress_Holder label .req-indicator")
          .length == 0
      )
        $("#Form_Form_OrganisationStreetAddress_Holder label").append(req);

      $("#Form_Form_OrganisationCity").attr("required", "required");
      if (
        $("#Form_Form_OrganisationCity_Holder label .req-indicator").length == 0
      )
        $("#Form_Form_OrganisationCity_Holder label").append(req);

      $("#Form_Form_OrganisationPostCode").attr("required", "required");
      if (
        $("#Form_Form_OrganisationPostCode_Holder label .req-indicator")
          .length == 0
      )
        $("#Form_Form_OrganisationPostCode_Holder label").append(req);
    } else {
      $("#Form_Form_OrganisationName").attr("required", false);
      $("#Form_Form_OrganisationName_Holder label .req-indicator").remove();

      $("#Form_Form_OrganisationContactName").attr("required", false);
      $(
        "#Form_Form_OrganisationContactName_Holder label .req-indicator"
      ).remove();

      $("#Form_Form_OrganisationEmail").attr("required", false);
      $("#Form_Form_OrganisationEmail_Holder label .req-indicator").remove();

      $("#Form_Form_OrganisationPhone").attr("required", false);
      $("#Form_Form_OrganisationPhone_Holder label .req-indicator").remove();

      $("#Form_Form_OrganisationStreetAddress").attr("required", false);
      $(
        "#Form_Form_OrganisationStreetAddress_Holder label .req-indicator"
      ).remove();

      $("#Form_Form_OrganisationCity").attr("required", false);
      $("#Form_Form_OrganisationCity_Holder label .req-indicator").remove();

      $("#Form_Form_OrganisationPostCode").attr("required", false);
      $("#Form_Form_OrganisationPostCode_Holder label .req-indicator").remove();
    }
    $("#Form_Form_FirstName").attr("aria-required", state);
    $("#Form_Form_OrganisationContactName").attr("aria-required", state);
    $("#Form_Form_OrganisationEmail").attr("aria-required", state);
    $("#Form_Form_OrganisationPhone").attr("aria-required", state);
    $("#Form_Form_OrganisationStreetAddress").attr("aria-required", state);
    $("#Form_Form_OrganisationCity").attr("aria-required", state);
    $("#Form_Form_OrganisationPostCode").attr("aria-required", state);
  }

  $("#Form_Form_AddressIncorrect_1").on("change", function () {
    if ($(this).prop("checked", true)) {
      requireJuryAddress(false);
    } else if ($("#Form_Form_AddressIncorrect_2").prop("checked", true)) {
      requireJuryAddress(true);
    }
  });

  $("#Form_Form_AddressIncorrect_2").on("change", function () {
    if ($(this).prop("checked", true)) {
      requireJuryAddress(true);
    } else if ($("#Form_Form_AddressIncorrect_1").prop("checked", true)) {
      requireJuryAddress(false);
    }
  });

  $("#Form_Form_IndividualInfo_1").on("change", function () {
    if ($(this).prop("checked", true)) {
      requireIndividualDetails(true), requireorganisationDetails(false);
    } else if ($("#Form_Form_IndividualInfo_2").prop("checked", true)) {
      requireorganisationDetails(true), requireIndividualDetails(false);
    }
  });

  $("#Form_Form_IndividualInfo_2").on("change", function () {
    if ($(this).prop("checked", true)) {
      requireorganisationDetails(true), requireIndividualDetails(false);
    } else if ($("#Form_Form_IndividualInfo_1").prop("checked", true)) {
      requireIndividualDetails(true), requireorganisationDetails(false);
    }
  });

  $("#Form_Form_KMsFromCourt_Holder").hide();
  /*	$('#Form_Form_AddressIncorrect input').trigger('change');
   */

  function isHigh(string) {
    var v = string.toLowerCase().indexOf("high");
    return v > -1 ? true : false;
  }

  $("select[data-apply-select2]").select2({
    placeholder: $(this).data('placeholder'),
    allowClear: true,
    width: 'style',
  });
  $("#Form_Form_CourtName, #Form_Form_PrivateTransport").on(
    "change",
    function () {
      var data = $("#Form_Form_CourtName").select2("data");
      if (!data) {
        $("#Form_Form_KMsFromCourt_Holder").hide();
        return;
      }

      if (data) {
        var content = data[0].text;
        var privateTransport = $("#Form_Form_PrivateTransport").is(":checked");

        if (isHigh(content) && privateTransport) {
          $("#Form_Form_KMsFromCourt_Holder").show();
        } else {
          $("#Form_Form_KMsFromCourt_Holder").hide();
        }
      } else {
        $("#Form_Form_KMsFromCourt_Holder").hide();
      }
    }
  );

  var placeSearch, autocomplete;

  function initAutocomplete() {
    // Create the autocomplete object, restricting the search to geographical
    // location types.

    if (typeof google === "undefined") {
      return;
    }

    if (document.getElementById("Form_Form_StreetAddress")) {
      autocomplete = new google.maps.places.Autocomplete(
        document.getElementById("Form_Form_StreetAddress"),
        {
          /* types: ['(address)'],*/ componentRestrictions: { country: "nz" },
        }
      );
      autocomplete.setFields(["address_components"]);
      // When the user selects an address from the dropdown, populate the address
      // fields in the form.
      autocomplete.addListener("place_changed", fillInAddress);
    }
  }

  initAutocomplete();

  function fillInAddress() {
    // Get the place details from the autocomplete object.
    var place = autocomplete.getPlace();

    var components = {
      postal_code: "#Form_Form_PostCode",
      administrative_area_level_1: "#Form_Form_City",
    };

    for (var index in components) {
      $(components[index]).val("");
    }

    for (var i = 0; i < place.address_components.length; i++) {
      var addressType = place.address_components[i].types[0];
      for (var index in components) {
        if (addressType == index) {
          $(components[index]).val(place.address_components[i]["long_name"]);
        }
      }
    }
  }
});

(function ($) {
  $(document).ready(function () {
    $(".ajaxselect2").on("open", function (e) {
      $(".select2-search input").prop("focus", false);
    });

    // Only allow numeric input for number fields and respect max length.
    $('input[type="number"][maxlength]').on("input", function (event) {
      const $field = $(this);
      const maxlength = $field.attr("maxlength");
      // Get input key.
      let input = event.originalEvent.data;
      if (input === undefined) {
        input = $field.val().charAt($field.val().length - 1);
      }
      // Ensure numeric input only for browsers that don't support HTML5 number fields.
      const inputNotNumeric = input !== null && isNaN(parseInt(input));
      // Ensure maxlength is respected for browsers that DO support HTML5 number fields.
      const tooManyChars = maxlength && $field.val().length > maxlength;
      if (inputNotNumeric || tooManyChars) {
        $field.val($field.val().slice(0, -1));
        return false;
      }
    });

    // Validate against min and max length for numeric fields on form submission.
    // Note that using $('form').on('submit') would be too late to use setCustomValidity
    $('form input[type="submit"], form button').on("click", function () {
      const $form = $(this).closest("form");

      // Set validity for maxlength number fields.
      $form
        .find('input[type="number"][maxlength]')
        .each(function (index, elem) {
          elem.setCustomValidity("");
          const $elem = $(elem);
          if (!$elem.is(":hidden")) {
            const maxlength = $elem.attr("maxlength");
            if (maxlength && $elem.val().length > maxlength) {
              elem.setCustomValidity(
                "Must be " + maxlength + " characters or less."
              );
            }
          }
        });

      // Set validity for minlength number fields.
      $form
        .find('input[type="number"][minlength]')
        .each(function (index, elem) {
          elem.setCustomValidity("");
          const $elem = $(elem);
          if (!$elem.is(":hidden")) {
            const minlength = $elem.attr("minlength");
            if (minlength && $elem.val().length < minlength) {
              elem.setCustomValidity(
                "Must be " + minlength + " characters or more."
              );
            }
          }
        });
    });
  });
})(jQuery);

// Ensure that only valid date ranges can be selected for PDLA roster form
(function ($) {
  $(document).ready(() => {
    $('#Form_Form_StartDate').on('change', function() {
      if ($('#Form_Form_StartDate').val() > $('#Form_Form_EndDate').val()) {
        $('#Form_Form_EndDate').val($('#Form_Form_StartDate').val())
      };
    });
    $('#Form_Form_EndDate').on('change', function() {
      if ($('#Form_Form_StartDate').val() > $('#Form_Form_EndDate').val()) {
        $('#Form_Form_StartDate').val($('#Form_Form_EndDate').val())
      };
    });
  });
}(jQuery));
